import {observer} from "mobx-react";
import HelpIcon from "../../../ui/5.0/icons/circle-question.svg?react";
import {SelectInputV5} from "../input/select/SelectInputV5";
import type {IFieldDataTypeSettingsProps} from "../../modules/settings/modules/field/datatypes/IFieldDataTypeSettingsProps";
import {FieldDataType} from "../../../generated/api/base";
import {FieldV5} from "./FieldV5";
import {SingleLineLabelV5} from "./datatypes/SingleLineLabelV5";

type PeopleFieldVariant = "Single" | "Multiple";
const SelectionModeLabel = "Selection Mode";

export const PeopleFieldSettingsV5 = observer((props: IFieldDataTypeSettingsProps) => {
	const {onChange, field} = props;
	const {isVariantSet} = field;

	const onSetVariant = (variant: PeopleFieldVariant) => {
		field.isVariantSet = true;
		field.dataType = variant === "Single" ? FieldDataType.PeopleSingleChoiceList : FieldDataType.PeopleMultipleChoiceList;
		onChange();
	};

	const isInEditMode = !!field.refId;
	const variantLabel = field.dataType === FieldDataType.PeopleSingleChoiceList ? "Single" : "Multiple";

	return (
		<FieldV5
			label={SelectionModeLabel}
			icons={{postLabelIcon: HelpIcon}}
			tooltips={{
				postLabelIconTooltip: "Choose single or multiple user selection for this field. Once created, this cannot be changed.",
			}}
			className="higher"
		>
			{isInEditMode ? (
				<SingleLineLabelV5 value={variantLabel} />
			) : (
				<SelectInputV5
					selected={isVariantSet ? variantLabel : null}
					options={["Single", "Multiple"] as PeopleFieldVariant[]}
					isSameWidth={true}
					sort={false}
					onChange={onSetVariant}
					placeholder={SelectionModeLabel}
				/>
			)}
		</FieldV5>
	);
});
